import {  useState } from 'react';
import { Navbar, Nav, Container, Image, Dropdown, Button, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../../services/login.services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo1 from '../../../../assets/logo1.png';
import logo2 from '../../../../assets/logo2.png';
import { colors } from '../../../../utils/Colors';
import { useAppData } from '../../../../context';

const AdminHeader = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const { newBookingsCount, newContactsCount } = useAppData();

  const [loading, setLoading] = useState({
    bookings: false,
    contacts: false
  });



  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully!');
    navigate('/admin/login');
  };

  const handleNavClick = (path) => {
    navigate(path);
    setExpanded(false);
  };

  // Count animation styles
  const badgeStyles = {
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    fontSize: '0.7rem',
    minWidth: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: newBookingsCount > 0 || newContactsCount > 0 ? 'pulse 1.5s infinite' : 'none'
  };

  const navItemWithBadge = {
    position: 'relative',
    paddingRight: '25px !important'
  };


  const styleTag = `
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.1); }
      100% { transform: scale(1); }
    }
    
    .nav-item-with-badge {
      position: relative;
    }
    
    .count-badge {
      position: absolute;
      top: -8px;
      right: -8px;
      font-size: 0.7rem;
      min-width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .blink {
      animation: blink 1s infinite;
    }
    
    @keyframes blink {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
  `;

  return (
    <>
      <style>{styleTag}</style>
      <ToastContainer position="top-right" autoClose={3000} />

      <Navbar
        bg={colors.PRIMARY}
        variant="dark"
        expand="lg"
        fixed="top"
        expanded={expanded}
        style={{
          borderBottom: `2px solid ${colors.TABLE_HEADERS}`,
          padding: '10px 0',
          backgroundColor: colors.PRIMARY,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 1050
        }}
      >
        <Container fluid>
          <Navbar.Brand
            href="#"
            onClick={() => handleNavClick('/admin/dashboard')}
            style={{
              cursor: 'pointer',
              marginRight: '40px',
              color: '#fff'
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <Image
                src={logo1}
                height={45}
                alt="Logo 1"
                style={{ objectFit: 'contain' }}
              />
              <Image
                src={logo2}
                height={45}
                alt="Logo 2"
                style={{ objectFit: 'contain' }}
              />
              <div className="d-none d-md-block">
                <span style={{
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  color: '#fff',
                  marginLeft: '10px',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
                }}>
                  Admin Panel
                </span>
              </div>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="navbar-nav"
            onClick={() => setExpanded(!expanded)}
            style={{
              borderColor: 'rgba(255,255,255,0.5)'
            }}
          />

          <Navbar.Collapse id="navbar-nav">
            <Nav className="me-auto">

              <Dropdown as={Nav.Item} className="mx-2">
                <Dropdown.Toggle
                  as={Nav.Link}
                  className="d-flex align-items-center"
                  style={{
                    color: '#fff',
                    fontWeight: '500',
                    cursor: 'pointer',
                    backgroundColor: 'transparent',
                    border: 'none',
                    padding: '8px 15px',
                    borderRadius: '4px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  <i className="fas fa-users me-2"></i>
                  Users
                </Dropdown.Toggle>
                <Dropdown.Menu style={{
                  backgroundColor: colors.PRIMARY,
                  border: `1px solid ${colors.TABLE_HEADERS}`,
                  marginTop: '8px'
                }}>
                  <Dropdown.Item
                    onClick={() => handleNavClick('/admin/dashboard/all-user')}
                    style={{
                      color: '#fff',
                      padding: '10px 20px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = colors.TABLE_HEADERS;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    <i className="fas fa-list me-2"></i>
                    User List
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleNavClick('/admin/dashboard/create-user')}
                    style={{
                      color: '#fff',
                      padding: '10px 20px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = colors.TABLE_HEADERS;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    <i className="fas fa-user-plus me-2"></i>
                    Create User
                  </Dropdown.Item>
                  <Dropdown.Divider style={{ backgroundColor: colors.TABLE_HEADERS }} />
                </Dropdown.Menu>
              </Dropdown>

              {/* Bills Dropdown */}
              <Dropdown as={Nav.Item} className="mx-2">
                <Dropdown.Toggle
                  as={Nav.Link}
                  className="d-flex align-items-center"
                  style={{
                    color: '#fff',
                    fontWeight: '500',
                    cursor: 'pointer',
                    backgroundColor: 'transparent',
                    border: 'none',
                    padding: '8px 15px',
                    borderRadius: '4px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  <i className="fas fa-file-invoice-dollar me-2"></i>
                  Bills
                </Dropdown.Toggle>
                <Dropdown.Menu style={{
                  backgroundColor: colors.PRIMARY,
                  border: `1px solid ${colors.TABLE_HEADERS}`,
                  marginTop: '8px'
                }}>
                  <Dropdown.Item
                    onClick={() => handleNavClick('/admin/dashboard/bills-list')}
                    style={{
                      color: '#fff',
                      padding: '10px 20px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = colors.TABLE_HEADERS;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    <i className="fas fa-list-alt me-2"></i>
                    All Bills
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleNavClick('/admin/dashboard/create-bill')}
                    style={{
                      color: '#fff',
                      padding: '10px 20px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = colors.TABLE_HEADERS;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    <i className="fas fa-plus-circle me-2"></i>
                    Create Bill
                  </Dropdown.Item>
                  <Dropdown.Divider style={{ backgroundColor: colors.TABLE_HEADERS }} />
                </Dropdown.Menu>
              </Dropdown>

       
              <Nav.Link
                onClick={() => {
                  handleNavClick('/admin/dashboard/bookings');
                  // setnewBookingsCount(0);
                }}
                className="mx-2 d-flex align-items-center position-relative"
                style={{
                  color: '#fff',
                  fontWeight: '500',
                  padding: '8px 15px',
                  borderRadius: '4px',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                <i className="fas fa-calendar-check me-2"></i>
                Bookings
                {newBookingsCount > 0 && (
                  <Badge
                    pill
                    bg="danger"
                    style={{
                      position: 'absolute',
                      top: '0px',
                      right: '0px',
                      fontSize: '0.65rem',
                      minWidth: '25px',
                      height: '25px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      animation: 'pulse 1.5s infinite',
                      border: '2px solid #fff'
                    }}
                  >
                    {newBookingsCount > 99 ? '99+' : newBookingsCount}
                  </Badge>
                )}
                {loading.bookings && (
                  <Badge
                    pill
                    bg="warning"
                    style={{
                      position: 'absolute',
                      top: '0px',
                      right: '0px',
                      fontSize: '0.65rem',
                      minWidth: '25px',
                      height: '25px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      animation: 'blink 1s infinite'
                    }}
                  >
                    ...
                  </Badge>
                )}
              </Nav.Link>

          
              <Nav.Link
                onClick={() => {
                  handleNavClick('/admin/dashboard/contacts');
                }}
                className="mx-2 d-flex align-items-center position-relative"
                style={{
                  color: '#fff',
                  fontWeight: '500',
                  padding: '8px 15px',
                  borderRadius: '4px',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                <i className="fas fa-address-book me-2"></i>
                Contacts
                {newContactsCount > 0 && (
                  <Badge
                    pill
                    bg="danger"
                    style={{
                      position: 'absolute',
                      top: '0px',
                      right: '0px',
                      fontSize: '0.65rem',
                      minWidth: '25px',
                      height: '25px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      animation: 'pulse 1.5s infinite',
                      border: '2px solid #fff'
                    }}
                  >
                    {newContactsCount > 99 ? '99+' : newContactsCount}
                  </Badge>
                )}
                {loading.contacts && (
                  <Badge
                    pill
                    bg="warning"
                    style={{
                      position: 'absolute',
                      top: '0px',
                      right: '0px',
                      fontSize: '0.65rem',
                      minWidth: '25px',
                      height: '25px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      animation: 'blink 1s infinite'
                    }}
                  >
                    ...
                  </Badge>
                )}
              </Nav.Link>

        
              <Nav.Link
                onClick={() => handleNavClick('/admin/dashboard/gallery')}
                className="mx-2 d-flex align-items-center"
                style={{
                  color: '#fff',
                  fontWeight: '500',
                  padding: '8px 15px',
                  borderRadius: '4px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255,255,255,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                <i className="fas fa-images me-2"></i>
                Gallery
              </Nav.Link>
            </Nav>


           
            <Nav className="align-items-center">
              <Button
                variant="outline-light"
                onClick={handleLogout}
                className="ms-2"
                style={{
                  borderWidth: '2px',
                  fontWeight: '500',
                  padding: '8px 20px',
                  borderColor: colors.TABLE_HEADERS,
                  color: '#fff',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = colors.TABLE_HEADERS;
                  e.target.style.borderColor = colors.TABLE_HEADERS;
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.borderColor = colors.TABLE_HEADERS;
                }}
              >
                <i className="fas fa-sign-out-alt me-2"></i>
                Logout
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

    
      <div style={{ height: '20px' }}></div>
    </>
  );
};

export default AdminHeader;